<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  (onShowHelpPage)="onShowHelpPage()"
>
  <!--------------------------------------------------------------- Table Content ---------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- impersonator UserName -->
        <td class="tw-relative">
          <td-value
            copyToClipboard
            [value]="item?.impersonatorUserName"
          ></td-value>
          <!-- <i class="mdi mdi-arrow-left mdi-24px tw-text-gray-600 tw-absolute" style="left:-12px"></i> -->
        </td>

        <!-- impersonated UserName -->
        <td>
          <td-value
            copyToClipboard
            [value]="item?.impersonatedUserName"
          ></td-value>
        </td>

        <!-- impersonator OrganizationName -->
        <td class="tw-relative">
          <td-value
            copyToClipboard
            [value]="item?.impersonatorOrganizationName"
          ></td-value>
          <!-- <i class="mdi mdi-arrow-left mdi-24px tw-text-gray-600 tw-absolute" style="left:-12px"></i> -->
        </td>

        <!-- impersonated OrganizationName -->
        <td>
          <td-value
            copyToClipboard
            [value]="item?.impersonatedOrganizationName"
          ></td-value>
        </td>

        <!-- ipAddress -->
        <td>
          <td-value
            class="font-vazir-ui"
            copyToClipboard
            [value]="item?.ipAddress | ipDisplayer"
          ></td-value>
        </td>

        <!-- browser -->
        <td style="max-width: 200px">
          <span *ngIf="item?.browser" [matTooltip]="item?.browserName">
            <i [browserIcon]="item?.browser"></i>
          </span>
          <span *ngIf="!item?.browser">
            {{ item?.browserName }}
          </span>
        </td>

        <!-- device -->
        <td style="max-width: 200px">
          <span
            *ngIf="item?.device"
            [matTooltip]="item?.device | enumValue : Device"
          >
            <i [deviceIcon]="item?.device"></i>
          </span>
          <span *ngIf="!item?.device">
            {{ item?.device | enumValue : Device }}
          </span>
        </td>

        <!-- os -->
        <td style="max-width: 200px">
          <span *ngIf="item?.platform" [matTooltip]="item?.os">
            <i [platformIcon]="item?.platform"></i>
          </span>
          <span *ngIf="!item?.platform">
            {{ item?.os }}
          </span>
        </td>

        <!-- isSignOut -->
        <td>
          <span *ngIf="!item?.isSignOut">
            <i
              [matTooltip]="'common.login' | translate"
              class="mdi mdi-location-enter text-success mdi-22px mdi-rotate-180"
            ></i>
          </span>
          <span *ngIf="item?.isSignOut">
            <i
              [matTooltip]="'common.isSignOut' | translate"
              class="mdi mdi-location-exit text-danger mdi-22px"
            ></i>
          </span>
        </td>

        <!-- created -->
        <td>
          <td-value type="dateTime" [value]="item?.created"></td-value>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>
<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
